import ProductPriceListPreview from "./PrintProductPricePreview";

const PrintProductPriceList: React.FC = () => {
  return (
    <div className="inner-container">
      <ProductPriceListPreview />
    </div>
  );
};

export default PrintProductPriceList;
